import ShopComponent from '../components/shops/shop'

const Shop = () => <ShopComponent />

export default Shop;